module.exports = __webpack_public_path__ + "img/slide3.c7c6c584.png";